import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Icon from '../../components/Icon';
import { ISSUES_GROUP, SUPPORT_EMAIL } from '../../constants/api';
import { Diff } from './Diff';
import { Name } from './Name';
import { resolveFilterGroupType } from './Tabs';
import { TypeIcon } from './TypeIcon';
export const filterIssuesByType = (commitIssuesData, hiddenType, issuesLimit) => {
    const showType = resolveFilterGroupType(hiddenType);
    if (showType === ISSUES_GROUP.ALL) {
        return commitIssuesData.slice(0, issuesLimit);
    }
    const filteredByType = commitIssuesData.filter((issue) => showType === ISSUES_GROUP.ERRORS ? issue.isError : !issue.isError);
    return filteredByType.slice(0, issuesLimit);
};
const resolveHighlightedClasses = (issue, highlightedRules, handleRuleClick) => {
    const { name: issueName, ...issueProps } = issue;
    const showHighlightable = handleRuleClick && !issueProps.commitIssue;
    const haveHighlightedRule = highlightedRules && highlightedRules.includes(issueProps.tool + '#' + issueName);
    return clsx('most-common-issues__row', {
        'most-common-issues__row--highlightable': showHighlightable,
        'most-common-issues__row--highlighted': haveHighlightedRule,
    });
};
export const TableRows = (props) => {
    const { isLoading, className, hiddenType, twoColumns, isCommitProcessing, isCommitTimedOut, showIcon, highlightedRules, issuesLimit, defects, onRuleClick, } = props;
    const { t } = useTranslation();
    const group = resolveFilterGroupType(hiddenType);
    const filteredDefects = filterIssuesByType(defects, hiddenType, issuesLimit);
    const noIssuesTypeMessage = group === ISSUES_GROUP.ERRORS ? t('noErrorsFound') : t('noWarningsFound');
    const classes = clsx('most-common-issues__container', className, {
        'most-common-issues__container--two-columns': twoColumns && !isLoading,
    });
    return _jsx("div", { className: classes, children: !filteredDefects.length ? _jsxs("div", { className: 'row most-common-issues__row', children: [isCommitTimedOut && !twoColumns &&
                    _jsx("div", { className: 'maintenance-banner alert alert-warning', "data-testid": "commit-timeouted-banner", children: _jsx("span", { children: _jsxs(Trans, { i18nKey: "commitTimeouted", values: { email: SUPPORT_EMAIL }, children: ["Processing of this commit timed out. If you need help, please contact us on ", _jsx("a", { href: `mailto:${SUPPORT_EMAIL}`, children: SUPPORT_EMAIL }), "."] }) }) }), isCommitProcessing &&
                    _jsx(Icon, { name: 'spinner', pulse: true, fixedWidth: true, size: '3x', className: 'mx-auto' }), !isCommitProcessing && !isCommitTimedOut &&
                    _jsx("div", { className: 'col', children: group !== ISSUES_GROUP.ALL ? noIssuesTypeMessage : t('noIssuesFound') })] }) : filteredDefects.map((defect) => (_jsxs("div", { className: resolveHighlightedClasses(defect, highlightedRules, onRuleClick), children: [_jsx(Name, { defect: defect, onRuleClick: onRuleClick }), _jsx(Diff, { countDiff: defect.countDiff }), _jsx(TypeIcon, { defect: defect, group: group, showIcon: showIcon, onRuleClick: onRuleClick })] }, `${defect.name}-${defect.isError}`))) });
};
